import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "App",
      component: resolve => require(["@/App"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/computer/HomePage"], resolve),
          meta: {
            title: "联合新能源，让电动汽车无限续航"
          }
        },
        {
          path: "/mobile-home",
          name: "MobileHome",
          component: resolve => require(["@/view/mobile/MobileHome"], resolve),
          meta: {
            title: "联合新能源，让电动汽车无限续航"
          }
        },
        {
          path: "/software",
          name: "software",
          component: resolve => require(["@/view/computer/Software"], resolve),
          meta: {
            title: "整体方案 - 联合新能源，让电动汽车无限续航"
          }
          // children: [
          //   {
          //     path: '/software/smartTown',
          //     name: 'Software_smartTown',
          //     component: resolve => require(['@/view/computer/Software_smartTown'], resolve),
          //     meta: {
          //       title: '软件产品丨智能小镇管理系统'
          //     }
          //   },
          //   {
          //     path: '/software/bigData',
          //     name: 'Software_bigData',
          //     component: resolve => require(['@/view/computer/Software_bigData'], resolve),
          //     meta: {
          //       title: '软件产品丨大数据管理系统'
          //     }
          //   }
          // ]
        },
        {
          path: "/mobile-software",
          name: "MobileSoftware",
          component: resolve =>
            require(["@/view/mobile/MobileSoftware"], resolve),
          meta: {
            title: "整体方案 - 联合新能源，让电动汽车无限续航"
          }
        },
        // {
        //   path: '/software/smartTown',
        //   name: 'Software_smartTown',
        //   component: resolve => require(['@/view/computer/Software_smartTown'], resolve),
        //   meta: {
        //     title: '商用车/乘用车解决方案'
        //   }
        // },
        // {
        //   path: '/software/bigData',
        //   name: 'Software_bigData',
        //   component: resolve => require(['@/view/computer/Software_bigData'], resolve),
        //   meta: {
        //     title: '加油站'
        //   }
        // },
        {
          path: "/service",
          name: "service",
          component: resolve => require(["@/view/computer/Service"], resolve),
          meta: {
            title: "产品中心 - 联合新能源，让电动汽车无限续航"
          }
        },
        {
          path: "/mobile-service",
          name: "MobileService",
          component: resolve =>
            require(["@/view/mobile/MobileService"], resolve),
          meta: {
            title: "产品中心 - 联合新能源，让电动汽车无限续航"
          }
        },
        // {
        //   path: '/aboutUs',
        //   name: 'aboutUs',
        //   component: resolve => require(['@/view/computer/AboutUs'], resolve),
        //   meta: {
        //     title: '关于我们'
        //   }
        // },
        {
          path: "/NewsInformation",
          name: "NewsInformation",
          component: resolve =>
            require(["@/view/computer/NewsInformation"], resolve),
          meta: {
            title: "关于我们 - 联合新能源，让电动汽车无限续航"
          }
        },
        {
          path: "/Mobile-NewsInformation",
          name: "MobileNewsInformation",
          component: resolve =>
            require(["@/view/mobile/MobileNewsInformation"], resolve),
          meta: {
            title: "关于我们 - 联合新能源，让电动汽车无限续航"
          }
        },
        {
          path: "/NewDetails",
          name: "NewDetails",
          component: resolve =>
            require(["@/view/computer/NewDetails"], resolve),
          meta: {
            title: "新闻详情 - 联合新能源，让电动汽车无限续航"
          }
        },
        {
          path: "/NewsList",
          name: "NewsList",
          component: resolve => require(["@/view/computer/NewsList"], resolve),
          meta: {
            title: "新闻资讯 - 联合新能源，让电动汽车无限续航"
          }
        },
        {
          path: "/Mobile-NewsList",
          name: "MobileNewsList",
          component: resolve =>
            require(["@/view/mobile/MobileNewsList"], resolve),
          meta: {
            title: "新闻资讯 - 联合新能源，让电动汽车无限续航"
          }
        },
        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/computer/ContactUs"], resolve),
          meta: {
            title: "联系我们 - 联合新能源，让电动汽车无限续航"
          }
        },
        {
          path: "/Mobile-contactus",
          name: "MobileContactus",
          component: resolve =>
            require(["@/view/mobile/MobileContactus"], resolve),
          meta: {
            title: "联系我们 - 联合新能源，让电动汽车无限续航"
          }
        },
        // {
        //   path: '/companyintroduction',
        //   name: 'companyintroduction',
        //   component: resolve => require(['@/view/computer/CompanyIntroduction'], resolve),
        //   meta: {
        //     title: '公司介绍'
        //   }
        // },
        {
          path: "/jobchance",
          name: "jobchance",
          component: resolve => require(["@/view/computer/JobChance"], resolve),
          meta: {
            title: "投资加盟 - 联合新能源，让电动汽车无限续航"
          }
        },
        // {
        //   path: '/servicedetail',
        //   name: 'servicedetail',
        //   component: resolve => require(['@/view/computer/ServiceDetail'],resolve),
        //   meta: {
        //     title: '换电智慧系统'
        //   }
        // },
        // {
        //   path: '/PageView',
        //   name: 'PageView',
        //   component: resolve => require(['@/view/computer/PageView'],resolve),
        //   meta: {
        //     title: 'APP'
        //   }
        // },
        {
          path: "/Mobile-jobchance",
          name: "MobileJobchance",
          component: resolve =>
            require(["@/view/mobile/MobileJobChance"], resolve),
          meta: {
            title: "投资加盟 - 联合新能源，让电动汽车无限续航"
          }
        },
        {
          path: "/companydetails",
          name: "companydetails",
          component: resolve =>
            require(["@/view/computer/CompanyDetails"], resolve),
          meta: {
            title: "公司简介 - 联合新能源，让电动汽车无限续航"
          }
        },
        {
          path: "/Mobile-companydetails",
          name: "MobileCompanydetails",
          component: resolve =>
            require(["@/view/mobile/MobileCompanydetails"], resolve),
          meta: {
            title: "公司简介 - 联合新能源，让电动汽车无限续航"
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js